<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import * as axios from "axios";

const USERS_API_URL = process.env.VUE_APP_API_URL + 'users/';

export default {
  page: {
    title: 'Login',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      isEmailVerified: false,
      verifyMessage: ''
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            email: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
    token: function() {
      return this.$route.query['token']
    }
  },
  async mounted() {
      if(this.token){
          const response = await axios( USERS_API_URL + 'delete-token/' + this.token )
          if(response.data !== ''){
            this.isEmailVerified = true;
            this.verifyMessage = response.data
          }
      }
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the email
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true;
      // Reset the authError if it existed.
      this.isAuthError = false;
      this.authError = null;
      return this.logIn({
        email: this.email,
        password: this.password,
        token: this.token
      })
        .then((token) => {
          this.tryingToLogIn = false
          this.isAuthError = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error.message;
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center white-text top-space">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="">
          <div class="card-body p-4">
            <div class="text-center w-100 m-auto">
              <a href="/">
                <span
                  ><img src="@assets/images/logo-white.png" alt="" height="52"
                /></span>
              </a>
              <p class="mb-4 mt-3 secondary-text"
                >Enter your email address and password to access your dashboard.</p
              >
            </div>

            <b-alert v-model="isAuthError" variant="danger" dismissible class="alert-btn error">
              {{authError}}
            </b-alert>

            <b-alert v-model="isEmailVerified" variant="success" dismissible class="alert-btn success">
              {{verifyMessage}}
            </b-alert>

            <b-form @submit.prevent="tryToLogIn">
              <b-form-group
                id="input-group-1"
              >
              <i class=""><img src="@assets/images/user.png" alt="" height=""/></i>
                <input
                  id="input-1"
                  v-model="email"
                  type="text"
                  required
                  placeholder="Email"
                ></input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
              >
              <i class=""><img src="@assets/images/key.png" alt="" height=""/></i>
                <input
                  id="input-2"
                  v-model="password"
                  type="password"
                  required
                  placeholder="Password"
                ></input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4 text-center">
                <b-button type="submit" class="change-pwd-btn"
                  ></b-button
                >
              </b-form-group>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="row ">
          <div class="col-12 text-center">
            <p>
              <router-link tag="a" to="/forget-password" class="text-white-50 ml-1 forgot-pwd-link">Forgot your password?</router-link>
              </p
            >
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" scoped>
.white-text{
    color:white;
    font-size:1rem;
    font-weight: 200;
    font-family: "Ubuntu",sans-serif;
}
.forgot-pwd-link:hover{

    color: white !important;

}
i{
    position: relative;
    bottom: -28px;
    left: 12px;
    img{
        max-height: 20px;
        max-width: 30px;
    }
}
input{
    display: block;
    width: 100%;
    height: calc(1.5em + 0.9rem + 2px);
    padding: 0.45rem 0.9rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;

    background: rgba($color: #D3AED1, $alpha: 0.5);
    border: none;
    padding-left: 50px;
    border-radius: 20px;
    color: white;
    &::placeholder {
        color: white;
        font-weight: 200;
    }
    &:focus{
        background-color: rgba($color: #D3AED1, $alpha: 0.5);
        color: white
    }
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px #a76ca0 inset;
      -webkit-text-fill-color: white !important;
      &:focus{
        color: red;
      }
        
    }

}



button{
    background:url('~~~@assets/images/arrow.png') no-repeat right center;
    width: 40px;
    height: 40px;
    background-size: contain;
    
    border: none !important;
    &.change-pwd-btn{
    width: 40px;
    background-color: transparent !important;
    }
    &.login-btn{
        width: auto;
        padding-right: 50px;
        background-color: rgba($color: #D3AED1, $alpha: 0.5);
        border-radius: 20px;
        &:hover{
            background-color: rgba($color: #D3AED1, $alpha: 0.8);
        }
    }

}
.alert-btn {
    background-color: rgba($color: #D3AED1, $alpha: 0.5);
    font-size: 0.8rem;
    border: none;
    button{
    background-image: none;
    
    }
    &.error{
        color: #aaa0ff;
    }
    &.success{
        color: #24bc66
    }
   
}

.top-space{
  margin-top: 18vh;
}

@media (max-width: 1024px) and (orientation: portrait){
  .top-space{
    margin-top: 30vh;
  }
}

@media (max-width: 414px){
  .top-space{
    margin-top: 0;
  }
}
@media (max-width: 320px){
  .secondary-text{
    margin-bottom: 10px !important;
    font-size: 0.9rem;
  }

}
</style>
